import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useEvents } from "@/context/AppContext";
import { api } from "@/lib/api";
import { money, ago, fmtDateTime } from "@/lib/format";

const SALE_EVENTS = ["SALE_CREATED", "SALE_UPDATED", "SALE_DELETED", "SALE_REASSIGNED"];

// 🛍 ACQUISTI: the same sales as "Totale speso" (site sales + Stripe payments of this fan).
export function PurchasesCard({ fanId }) {
  const [d, setD] = useState(null);
  const [all, setAll] = useState(false);
  const load = () => api.get(`/fans/${fanId}/purchases`).then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, [fanId]); // eslint-disable-line
  useEvents(SALE_EVENTS, (e) => (!e?.fan_ids || e.fan_ids.includes(fanId)) && load());
  if (!d) return null;
  const l = d.last;
  return (
    <div className="mt-3 rounded-lg border border-[#232738] bg-[#12141D] p-3" data-testid="fan-purchases">
      <div className="mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-slate-400"><ShoppingBag className="h-3.5 w-3.5 text-emerald-400" />Acquisti</div>
      {!l ? <div className="text-xs text-slate-500" data-testid="fan-purchases-empty">Nessun acquisto</div> : <>
        <div className="text-[10px] uppercase text-slate-500">Ultimo acquisto</div>
        <div className="text-sm text-slate-200 truncate" data-testid="fan-purchases-last">{l.what} · <span className="num text-emerald-400">{money(l.amount)}</span></div>
        <div className="text-[10px] text-slate-500 truncate">{ago(l.at)}{l.by ? ` · ${l.by}` : ""}</div>
        <div className="mt-2 grid grid-cols-3 gap-1 text-center">
          {[["Acquisti", d.count, "count"], ["Spesa media", money(d.avg), "avg"], ["Più alto", money(d.max), "max"]].map(([k, v, id]) => <div key={k} className="rounded bg-[#0D0E14] p-1.5"><div className="text-[9px] uppercase text-slate-500">{k}</div><div className="num text-xs text-slate-100" data-testid={`fan-purchases-${id}`}>{v}</div></div>)}
        </div>
        {Math.abs(d.other) >= 0.01 && <div className="mt-1.5 text-[10px] text-slate-500" data-testid="fan-purchases-other">Totale speso {money(d.total_spent)} = acquisti {money(d.sum)} + importi inseriti a mano {money(d.other)}</div>}
        <button onClick={() => setAll(true)} className="mt-2 text-[11px] font-semibold text-violet-300 hover:text-violet-200" data-testid="fan-purchases-all-btn">Vedi tutti gli acquisti ›</button>
      </>}
      <Dialog open={all} onOpenChange={setAll}>
        <DialogContent className="max-w-lg bg-[#0D0E14] border-[#232738]" data-testid="fan-purchases-dialog">
          <DialogHeader><DialogTitle>Tutti gli acquisti · {money(d.sum)}</DialogTitle></DialogHeader>
          <div className="max-h-[60vh] overflow-y-auto thin-scroll">{d.items.map((i) => (
            <div key={i.id} className="flex items-center gap-2 border-t border-[#1A1D2B] py-1.5 text-xs" data-testid={`fan-purchase-${i.id}`}>
              <span className="w-28 shrink-0 text-slate-500">{fmtDateTime(i.at)}</span><span className="flex-1 truncate">{i.what}</span>
              <span className="text-slate-500 truncate max-w-[90px]">{i.by || "—"}</span><span className="rounded bg-white/5 px-1 text-[10px] text-slate-400">{i.via}</span><span className="num text-emerald-400">{money(i.amount)}</span>
            </div>))}</div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
